import axios from '@/libs/api.request';
import { sort_ASCII } from '@/libs/utils';
import { API_URL } from '@/config';

// 获取商品列表接口
export const productList = data =>
  axios.request({
    url: '/officialAccounts/product',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });

// 获取支付类型接口
export const payType = data =>
  axios.request({
    url: '/officialAccounts/payType',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });
export const getPayTypeNew = data =>
  axios.request({
    url: '/officialAccounts/payType/info',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });

// 下单接口
export const placeOrder = data =>
  axios.request({
    url: '/officialAccounts/jsApiOrder',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });

// 微信支付
export const officialAccountsPay = data =>
  axios.request({
    url: '/officialAccounts/pay',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });

// 小游戏支付检查设备
export const checkOs = data =>
  axios.request({
    url: '/wechat/app/pay/check-os',
    data
  });

// 根据unionId获取小游戏订单号
export const getOrderSn = params =>
  axios.request({
    url: '/wechat/game-custom/order',
    method: 'get',
    params
  });

// 获取礼包
export const getBag = data =>
  axios.request({
    url: '/user/gift_num',
    data: {
      ...data
    }
  });

// 签到 获取签到信息接口
export const signInInfo = data =>
  axios.request({
    url: '/officialAccounts/signIn/info',
    data: {
      ...data
    }
  });

// 签到 接口
export const signIn = data =>
  axios.request({
    url: '/officialAccounts/signIn',
    data: {
      ...data
    }
  });

// 支付宝使用拼接链接打开支付页
export const PAY_URL = `${API_URL}/officialAccounts/pay`;

// 代币订单创建订单接口
export const tokenOrder = data =>
  axios.request({
    url: '/officialAccounts/tokenOrder',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });

// 代币订单支付接口
export const tokenOrderPay = data =>
  axios.request({
    url: '/officialAccounts/tokenOrder/pay',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });
export const TOKEN_PAY_URL = `${API_URL}/officialAccounts/tokenOrder/pay`;

// 订单列表
export const orderList = data =>
  axios.request({
    url: '/officialAccounts/order/list',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });

// 检查订单
export const checkOrder = data =>
  axios.request({
    url: '/officialAccounts/order/show',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });

// 获取下单参数
export const getSyOrderData = data =>
  axios.request({
    url: '/pay/link/qrcode/detail',
    data: {
      ...data,
    }
  });

// 下单
export const payOrder = data =>
  axios.request({
    url: '/pay/order',
    data: {
      ...data,
    }
  });

// 微小切用户-线下支付获取订单信息
export const getLeadOfflineOrderInfo = data =>
  axios.request({
    url: '/wechat-lead/offline-order-info',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });

// 微小切用户-线下支付唤起支付
export const leadOfflinePay = data =>
  axios.request({
    url: '/wechat-lead/offline-pay',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });

// 埋点数据上报
export const burnReport = data =>
  axios.request({
    url: '/noncore/event-track/extra',
    data: {
      ...data,
      sign: sort_ASCII(data)
    }
  });